import { isRTL, getSiteLanguage, isSEO } from '../helpers';
import { editorMode, mobileMode, previewMode, siteMode, SSREnv, } from './constants';
var ViewerScriptEnvironment = /** @class */ (function () {
    function ViewerScriptEnvironment(options) {
        var _a;
        this.entry = 'viewerScript';
        var wixAPI = options.wixAPI, appParams = options.appData;
        this.isSSR = wixAPI.window.rendering.env === SSREnv;
        this.isSEO = isSEO(wixAPI);
        this.isMobile = wixAPI.window.formFactor === mobileMode;
        this.isEditor = wixAPI.window.viewMode === editorMode;
        this.isPreview = wixAPI.window.viewMode === previewMode;
        this.isViewer = wixAPI.window.viewMode === siteMode;
        this.isBlocksPreview = (_a = appParams === null || appParams === void 0 ? void 0 : appParams.appData) === null || _a === void 0 ? void 0 : _a.blocksPreviewData;
        this.language = getSiteLanguage(wixAPI, this.isEditor);
        this.isRTL = isRTL(this.language);
        this.multilingual = wixAPI.window.multilingual;
        this.appDefinitionId = appParams.appDefinitionId;
    }
    return ViewerScriptEnvironment;
}());
export { ViewerScriptEnvironment };
//# sourceMappingURL=ViewerScript.js.map